import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to Pharmacy/Medication if available
import pharmacyBg1 from './Pahrmacy.png'; // Kept original paths, rename/replace images as needed
import pharmacyBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Pharmacy = () => { // Changed component name
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have pharmacy-specific visuals
    const images = [pharmacyBg1]; // Used renamed variables for clarity
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

          

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         {/* Updated Header Text */}
                                         <strong>Pharmacy Services at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     {/* Updated Content: Introduction */}
                                     <h3>Pharmacy Department at Hitkari Hospital</h3>
                                       <p>The Pharmacy Department at Hitkari Hospital plays a crucial role in patient care by ensuring the safe, effective, and efficient use of medications. Staffed by qualified pharmacists and trained technicians, our pharmacy provides comprehensive services for inpatients and outpatients. We are committed to accuracy in dispensing, providing essential drug information, and collaborating closely with healthcare providers to optimize medication therapy for all our patients.</p>
                                </div>
                                <div className="terms-text">
                                    {/* Updated Content: Core Services */}
                                    <h3>Core Pharmacy Services</h3>
                                    <h4>1. Medication Dispensing</h4>
                                    <ul>
                                        <li>Prescription Fulfillment: Accurately dispensing medications prescribed by Hitkari Hospital doctors and external physicians.</li>
                                        <li>Over-the-Counter (OTC) Medications: Providing access to a range of non-prescription medicines, health supplements, and wellness products.</li>
                                        <li>Inpatient Medication Supply: Ensuring timely delivery of medications to patients admitted to the hospital wards and intensive care units.</li>
                                        <li>Unit Dose Dispensing: Preparing medications in ready-to-administer single doses for inpatients to enhance safety and accuracy.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       {/* Updated Content: Medication Safety */}
                                       <h4>2. Medication Safety and Management</h4>
                                        <ul>
                                            <li>Prescription Verification: Thorough review of prescriptions for appropriateness, dosage accuracy, potential drug interactions, and allergies.</li>
                                            <li>Drug Interaction Screening: Utilizing advanced software and clinical knowledge to check for potential harmful interactions between different medications.</li>
                                            <li>Allergy Checks: Verifying patient allergy information before dispensing to prevent adverse reactions.</li>
                                            <li>Medication Storage: Adhering to strict guidelines for the proper storage of medications, including temperature control for sensitive drugs.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      {/* Updated Content: Patient Guidance */}
                                      <h4>3. Patient Counseling and Drug Information</h4>
                                      <ul>
                                            <li>Medication Guidance: Providing clear instructions to patients on how to take their medications correctly, including dosage, timing, and duration.</li>
                                            <li>Side Effect Information: Educating patients about potential side effects and what to do if they occur.</li>
                                            <li>Drug Information Resource: Serving as a reliable source of information for patients and healthcare professionals regarding medications, their uses, and precautions.</li>
                                            <li>Device Training: Demonstrating the proper use of medical devices like inhalers or insulin pens when needed.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       {/* Updated Content: Inventory & Collaboration */}
                                       <h4>4. Inventory Management and Collaboration</h4>
                                        <ul>
                                            <li>Stock Management: Maintaining an adequate and diverse inventory of essential medicines, surgical supplies, and healthcare products.</li>
                                            <li>Quality Assurance: Ensuring all medications stocked are sourced from reputable suppliers and meet quality standards.</li>
                                            <li>Collaboration with Healthcare Team: Working closely with doctors, nurses, and other clinicians to ensure seamless medication management and address any therapy-related issues.</li>
                                            <li>Formulary Management: Participating in the selection of effective and cost-efficient medications available within the hospital system.</li>
                                        </ul>
                                </div>
                                 {/* Removed the 6th section to keep similar structure (5 specific + intro + conclusion) */}
                                  <div className="terms-text">
                                      {/* Updated Content: Why Choose */}
                                    <h3>Why Choose the Pharmacy at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Qualified Pharmacists: Experienced and knowledgeable pharmacists dedicated to patient safety and care.</li>
                                           <li>Comprehensive Medication Access: Wide range of prescription and OTC medications readily available.</li>
                                            <li>Emphasis on Safety: Rigorous checks and processes to minimize medication errors and ensure patient well-being.</li>
                                            <li>Convenient Location: Easily accessible pharmacy services within the hospital premises for inpatients and outpatients.</li>
                                           <li>Reliable Drug Information: Trustworthy guidance and counseling on medication usage provided by pharmacy staff.</li>
                                           <li>Integrated Care: Seamless coordination with your Hitkari Hospital doctors and nurses for optimal treatment outcomes.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    {/* Updated Content: Conclusion */}
                                    <p>The Hitkari Hospital Pharmacy is committed to being a trusted partner in your health journey. We strive to provide accurate, safe, and efficient pharmacy services, ensuring you receive the right medications along with the necessary guidance for their effective use, contributing to better health outcomes and overall well-being.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Pharmacy; // Make sure to export the correct component name